import { EmailShareButton } from 'react-share'
import React, { Component } from 'react'
import { RaisedButton } from 'material-ui'
import muiThemeable from 'material-ui/styles/muiThemeable'

import { trackEvent } from '../../app/ga'
import TextField from '../../components/TextField'
import Msg from '../../components/Msg'
import { SafeStorage } from '../../common/storageUtil'
import SendIcon from '../../assets/svg/SendIcon'

const LS_KEY = 'presentation_notes_'

class PresentationNotes extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // presentation should be "constant" per instance
      notes: SafeStorage.get(LS_KEY + props.presentation.title) || '',
      // initial readOnly=true is IOS safari workaround
      // test case: click on presentation in program -> keyboard should NOT open
      readOnly: true,
    }
  }

  handleChangeNotes = event => {
    this.trackTyping()
    const notes = event.target.value
    SafeStorage.set(LS_KEY + this.props.presentation.title, notes)
    this.setState({
      notes,
    })
  }

  trackTyping = () => {
    if (!this._typingGaSent) {
      trackEvent('notes', 'typing', this.props.presentation.title)
      this._typingGaSent = true
    }
  }

  trackEmailShare = () => {
    trackEvent('notes', 'shareEmail', this.props.presentation.title)
  }

  componentDidMount() {
    setTimeout(() => this.setState({ readOnly: false }), 100)
  }

  render() {
    const { appTitle, presentation, muiTheme } = this.props
    const { raisedButton: { style: buttonStyle } } = muiTheme
    const { title, presenter } = presentation
    return (
      <div>
        <div>
          <h4>
            <Msg id="PresentationNotes.title" />
          </h4>
          <TextField
            hintText={<Msg id="PresentationNotes.hint" />}
            multiLine={true}
            rows={7}
            fullWidth={true}
            onChange={this.handleChangeNotes}
            value={this.state.notes}
            readOnly={this.state.readOnly}
            style={{ borderRadius: 6, boxShadow: '2px 1px 2px 0px #dddddd' }}
          />
        </div>
        <div>
          <EmailShareButton
            url={window.location.href}
            subject={appTitle + ' | ' + presenter.fullName + ': ' + title}
            body={this.state.notes}
          >
            <RaisedButton
              primary
              fullWidth
              onClick={this.trackEmailShare}
              buttonStyle={buttonStyle}
              label={<Msg id="PresentationNotes.shareMail" />}
              labelPosition="after"
              labelStyle={{ verticalAlign: 'middle' }}
              icon={<SendIcon style={{ width: 20, height: 18 }} />}
            />
          </EmailShareButton>
        </div>
      </div>
    )
  }
}

export default muiThemeable()(PresentationNotes)



// WEBPACK FOOTER //
// ./src/containers/PresentationDetail/PresentationNotes.js